import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { getFastNav } from '../../model/registry'
import { APP_REGISTRY } from '../../model/appRegistry'
import useTranslation from '../../hooks/useTranslation'
import { media } from '../../styles/media'
import { useSnapshot } from 'valtio'
import { headerStore } from '../../state/headerStore'
import BackButton from '../generic/BackButton'

// Only on a wide screen: below that the header row is full and the page
// keeps its own title row (ViewTitle).
const Title = styled.h2`
  display: none;
  margin: 0 0 0 0.75rem;
  /* The page's name is the top of its hierarchy: the full h2 size. */
  font-size: var(--font-L);
  font-weight: 600;
  min-width: 0;
  align-self: center;
  align-items: center;

  ${media.laptop} {
    display: flex;
  }

  svg {
    flex: none;
    margin-bottom: 0;
  }
`

const Label = styled.span`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

// The menu entry a path belongs to: the longest menu path it equals or sits
// under, so /sales/invoice and /sales/invoice/123 both resolve to Invoices.
export const findMenuItem = (pathname) => {
  let best = null
  for (const item of getFastNav()) {
    if (pathname !== item.path && !pathname.startsWith(`${item.path}/`)) continue
    if (!best || item.path.length > best.path.length) best = item
  }
  return best
}

function HeaderTitle() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const item = useMemo(() => findMenuItem(pathname), [pathname])
  const snap = useSnapshot(headerStore)

  if (!snap.title && !item) return null

  // An app's overview reads better under the app's own name.
  const app = APP_REGISTRY[item?.app]
  const label = snap.title
    ?? (item.title === 'all.menu.overview' && app ? app.title : item.title)

  return (
    <Title data-testid='header.title'>
      {snap.back && <BackButton config={{ entity: 'header' }} />}
      <Label>{t(label)}</Label>
    </Title>
  )
}

export default HeaderTitle
